module.exports = __webpack_public_path__ + "static/img/3254_phase_function_Paper_PointsHejduk_Prediction.c9446ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3254_phase_function_Paper_PointsHejduk_Prediction.png
// module id = pXJy
// module chunks = 0